import React from 'react';

import ModalContact from './ModalContact';
import ModalConsultForm from './ModalConsult';
import ModalCreateForm from './ModalCreate';
import ModalJoinForm from './ModalJoin';
import ModalPracForm from './ModalPractices';

import ModalReel from './ModalReel';
import ModalAbout from './ModalAbout';
import ModalFilmsServices from './ModalFilmsServices';
import ModalPortfolioFilms from './ModalFilmsPortfolio';

import ModalReelStudio from './ModalReelStudio';
import ModalGire from './ModalGire';
import ModalTorres from './ModalTorres';
import ModalCharly from './ModalCharly';
import ModalBetvip from './ModalBetvip';
import ModalBetVip2 from './ModalBetvip2';
import ModalPuma from './ModalPuma';
import ModalSavile from './ModalSavile';
import ModalUnifin from './ModalUnifin';
import ModalInterceramic from './ModalInterceramic';
import ModalIdealz from './ModalIdealz';

import ModalKnockout from './ModalSpots/ModalSpotsKnockout';
import ModalLux from './ModalSpots/ModalSpotsLux';
import ModalRayados from './ModalSpots/ModalSpotsRayados';
import ModalChivas from './ModalSpots/ModalSpotsChivas';
import ModalGallos from './ModalSpots/ModalSpotsGallos';
import ModalSpotsInterceramic from './ModalSpots/ModalSpotsInterceramic';
import ModalBetcris from './ModalSpots/ModalSpotsBetcris';
import ModalCoca from './ModalSpots/ModalSpotsCoca';
import ModalCineminuto from './ModalSpots/ModalSpotsCineminuto';
import ModalOpticas from './ModalSpots/ModalSpotsOpticas';
import ModalLg from './ModalSpots/ModalSpotsLg';
import ModalExcelsior from './ModalSpots/ModalSpotsExcelsior';
import ModalRmx from './ModalSpots/ModalSpotsRmx';
import ModalMapaton from './ModalSpots/ModalSpotsMapaton';
import ModalBetcris2 from './ModalSpots/ModalSpotsBetcris2';
import ModalInterceramic2 from './ModalSpots/ModalSpotsInterceramic2';

import ModalCoprInterceramic from './ModalsCorp/ModalCorpInterceramic';
import ModalCorpAerolineas from './ModalsCorp/ModalCorpAerolineas';
import ModalCorpGaliper from './ModalsCorp/ModalCorpGaliper';

import ModalPostReel from './ModalsPost/ModalPostReel';
import ModalPostBetcris from './ModalsPost/ModalPostBetcris';
import ModalPostCharly from './ModalsPost/ModalPostCharly';
import ModalPostImagen from './ModalsPost/ModalPostImagen';
import ModalPostTeleton from './ModalsPost/ModalPostTeleton';
import ModalPostInterceramic from './ModalsPost/ModalPostInterceramic';
import ModalPostLg from './ModalsPost/ModalPostLg';
import ModalPostWarner from './ModalsPost/ModalPostWarner';

import ModalVideoLila from './ModalsVideoclips/ModalVideoLila';
import ModalVideoThalia from './ModalsVideoclips/ModalVideoThalia';
import ModalVideoAna from './ModalsVideoclips/ModalVideoAna';
import ModalVideoAlessandra from './ModalsVideoclips/ModalVideoAlessandra';
import ModalVideoBeto from './ModalsVideoclips/ModalVideoBeto';
import ModalVideoCentro from './ModalsVideoclips/ModalVideoCentro';

import ModalSocialGire from './ModalsSocial/ModalSocialGire';
import ModalSocialTeleton from './ModalsSocial/ModalSocialTeleton';
import ModalSocialAntes from './ModalsSocial/ModalSocialAntes';
import ModalSocialImplanon from './ModalsSocial/ModalSocialImplanon';

import ModalProductionServices from './ModalProductionServices';

import ModalAiServices from './ModalAiServices';
import ModalDavidC from './ModalsAiArtist/ModalDavidC';
import ModalAndresB from './ModalsAiArtist/ModalAndresB';
import ModalALvaroC from './ModalsAiArtist/ModalALvaroC';
import ModalRobot from './ModalsAiArtist/ModalRobot';
import ModalDavidN from './ModalsAiArtist/ModalDavidN';

import ModalVideoDavidC1 from './ModalsVideoArtistAi/ModalVideoDavidC1';

import ModalDirectors from './ModalDirectors';
import ModalNuno from './ModalsDirectors/ModalNuno';
import ModalMaria from './ModalsDirectors/ModalMaria';
import ModalBernardo from './ModalsDirectors/ModalBernardo';
import ModalCarlos from './ModalsDirectors/ModalCarlos';
import ModalRodrigo from './ModalsDirectors/ModalRodrigo';

import ModalPhotographers from './ModalPhotographers';
import ModalJose from './ModalsPhotographers/ModalJose';
import ModalYvone from './ModalsPhotographers/ModalYvone';
import ModalMario from './ModalsPhotographers/ModalMario';
import ModalGregory from './ModalsPhotographers/ModalGregory';
import ModalErick from './ModalsPhotographers/ModalErick';
import ModalPhotoCarlos from './ModalsPhotographers/ModalCarlos';
import ModalPhotoAlejandro from './ModalsPhotographers/ModalAlejandro';

import ModalClients from './ModalClients';

import ModalFashionKnockout from './ModalsPhoto/ModalFashionKnockout';
import ModalFashionVassarette from './ModalsPhoto/ModalFashionVassarette';
import ModalFashionFruit1 from './ModalsPhoto/ModalFashionFruit1';
import ModalFashionFruit2 from './ModalsPhoto/ModalFashionFruit2';
import ModalFashionCurvation from './ModalsPhoto/ModalFashionCurvation';
import ModalFashionVassarette2 from './ModalsPhoto/ModalFashionVassarette2';
import ModalRetratoFicj from './ModalsPhoto/ModalRetratoFicj';
import ModalRetratoGire from './ModalsPhoto/ModalRetratoGire';
import ModalDeportesGallos from './ModalsPhoto/ModalDeportesGallos';
import ModalDeportesGatorade from './ModalsPhoto/ModalDeportesGatorade';
import ModalDeportesPuma1 from './ModalsPhoto/ModalDeportesPuma1';
import ModalDeportesPuma2 from './ModalsPhoto/ModalDeportesPuma2';
import ModalDeportesPuma3 from './ModalsPhoto/ModalDeportesPuma3';
import ModalDrinksTorres10 from './ModalsPhoto/ModalDrinksTorres10';
import ModalDrinksTorres20 from './ModalsPhoto/ModalDrinksTorres20';
import ModalDrinksReal from './ModalsPhoto/ModalDrinksReal';
import ModalDrinksMagna from './ModalsPhoto/ModalDrinksMagna';
import ModalDrinksChateau from './ModalsPhoto/ModalDrinkChateau';
import ModalDrinksCodigo from './ModalsPhoto/ModalDrinksCodigo';
import ModalDrinksVasija from './ModalsPhoto/ModalDrinksVasija';
import ModalDrinksVinas from './ModalsPhoto/ModalDrinksVinas';
import ModalDrinksXa from './ModalsPhoto/ModalDrinksXa';
import ModalCultural from './ModalsPhoto/ModalCultural';
import ModalCampanasBetvip from './ModalsPhoto/ModalCampanasBetvip';
import ModalCampanasBetcris from './ModalsPhoto/ModalCampanasBetcris';
import ModalCampanasIdealz from './ModalsPhoto/ModalCampanasIdealz';
import ModalVideoDavidC2 from './ModalsVideoArtistAi/ModalVideoDadivC2';
import ModalVideoDavidC3 from './ModalsVideoArtistAi/ModalVideoDavid3';
import ModalVideoAlvaro1 from './ModalsVideoArtistAi/ModalVideoAlvaro1';
import ModalVideoAlvaro2 from './ModalsVideoArtistAi/ModalVideoALvaro2';
import ModalVideoAlvaro3 from './ModalsVideoArtistAi/ModalVideoAlvaro3';
import ModalVideoAndres1 from './ModalsVideoArtistAi/ModalVideoAndresB1';
import ModalVideoAndres2 from './ModalsVideoArtistAi/ModalVideoAndresB2';
import ModalVideoAndres3 from './ModalsVideoArtistAi/ModalVideoAndresB3';
import ModalVideoDavidN1 from './ModalsVideoArtistAi/ModalVideoDavidN1';
import ModalVideoDavidN2 from './ModalsVideoArtistAi/ModalVideoDavidN2';
import ModalVideoDavidN3 from './ModalsVideoArtistAi/ModalVideoDavidN3';
import ModalVideoRobot1 from './ModalsVideoArtistAi/ModalVideoRobot1';
import ModalVideoRobot2 from './ModalsVideoArtistAi/ModalVideoRobot2';
import ModalVideoRobot3 from './ModalsVideoArtistAi/ModalVideoRobot3';
import ModalVideoMaria1 from './ModalsDirectorsVideos/ModalVideoMaria1';
import ModalVideoMaria2 from './ModalsDirectorsVideos/ModalVideoMaria2';
import ModalVideoMaria3 from './ModalsDirectorsVideos/ModalVideoMaria3';
import ModalVideoMaria4 from './ModalsDirectorsVideos/ModalVideoMaria4';
import ModalVideoBernardo1 from './ModalsDirectorsVideos/ModalVideoBernardo1';
import ModalVideoBernardo2 from './ModalsDirectorsVideos/ModalVideoBernardo2';
import ModalVideoBernardo3 from './ModalsDirectorsVideos/ModalVideoBernardo3';
import ModalVideoBernardo4 from './ModalsDirectorsVideos/ModalVideoBernardo4';
import ModalVideoCarlos1 from './ModalsDirectorsVideos/ModalVideoCarlos1';
import ModalVideoCarlos2 from './ModalsDirectorsVideos/ModalVideoCarlos2';
import ModalVideoCarlos3 from './ModalsDirectorsVideos/ModalVideoCarlos3';
import ModalVideoCarlos4 from './ModalsDirectorsVideos/ModalVideoCarlos4';
import ModalVideoNuno1 from './ModalsDirectorsVideos/ModalVideoNuno1';
import ModalVideoNuno2 from './ModalsDirectorsVideos/ModalVideoNuno2';
import ModalVideoNuno3 from './ModalsDirectorsVideos/ModalVideoNuno3';
import ModalVideoNuno4 from './ModalsDirectorsVideos/ModalVideoNuno4';
import ModalVideoRodrigo1 from './ModalsDirectorsVideos/ModalVideoRodrigo1';
import ModalVideoRodrigo2 from './ModalsDirectorsVideos/ModalVideoRodrigo2';
import ModalVideoRodrigo3 from './ModalsDirectorsVideos/ModalVideoRodrigo3';
import ModalVideoRodrigo4 from './ModalsDirectorsVideos/ModalVideoRodrigo4';
import ModalGalleryAlejandro1 from './PhotographersGallery/ModalGalleryAlejandro1';
import ModalGalleryAlejandro2 from './PhotographersGallery/ModalGalleryAlejandro2';
import ModalGalleryAlejandro3 from './PhotographersGallery/ModalGalleryAlejandro3';
import ModalGalleryAlejandro4 from './PhotographersGallery/ModalGalleryAlejandro4';
import ModalGalleryCarlos1 from './PhotographersGallery/ModalGalleryCarlos1';
import ModalGalleryCarlos2 from './PhotographersGallery/ModalGalleryCarlos2';
import ModalGalleryCarlos3 from './PhotographersGallery/ModalGalleryCarlos3';
import ModalGalleryCarlos4 from './PhotographersGallery/ModalGalleryCarlos4';
import ModalGalleryErick1 from './PhotographersGallery/ModalGalleryErick1';
import ModalGalleryErick2 from './PhotographersGallery/ModalGalleryErick2';
import ModalGalleryGregory1 from './PhotographersGallery/ModalGalleryGregory1';
import ModalGalleryGregory2 from './PhotographersGallery/ModalGalleryGregory2';
import ModalGalleryGregory3 from './PhotographersGallery/ModalGalleryGregory3';
import ModalGalleryGregory4 from './PhotographersGallery/ModalGalleryGregory4';
import ModalGalleryMario1 from './PhotographersGallery/ModalGalleryMario1';
import ModalGalleryMario2 from './PhotographersGallery/ModalGalleryMario2';
import ModalGalleryMario3 from './PhotographersGallery/ModalGalleryMario3';
import ModalGalleryYvone1 from './PhotographersGallery/ModalGalleryYvone1';
import ModalGalleryYvone2 from './PhotographersGallery/ModalGalleryYvone2';
import ModalGalleryJose1 from './PhotographersGallery/ModalGalleryJose1';
import ModalGalleryJose2 from './PhotographersGallery/ModalGalleryJose2';
import ModalGalleryJose3 from './PhotographersGallery/ModalGalleryJose3';
import ModalLegal from './Legal/ModalLegal';
import ModalPrivacy from './Legal/ModalPrivacy';
import ModalPolicies from './Legal/ModalPolicies';
import ModalCookie from './Legal/ModalCookie';

const GlobalModals = () => {
  return (
    <>
      <ModalContact />
      <ModalConsultForm />
      <ModalCreateForm />
      <ModalJoinForm />
      <ModalPracForm />

      <ModalReel />
      <ModalAbout />
      <ModalFilmsServices />
      <ModalPortfolioFilms />

      <ModalReelStudio />
      <ModalGire />
      <ModalTorres />
      <ModalCharly />
      <ModalBetvip />
      <ModalBetVip2 />
      <ModalPuma />
      <ModalSavile />
      <ModalUnifin />
      <ModalInterceramic />
      <ModalIdealz />

      <ModalKnockout />
      <ModalLux />
      <ModalRayados />
      <ModalChivas />
      <ModalGallos />
      <ModalSpotsInterceramic />
      <ModalBetcris />
      <ModalCoca />
      <ModalCineminuto />
      <ModalOpticas />
      <ModalLg />
      <ModalExcelsior />
      <ModalRmx />
      <ModalMapaton />
      <ModalBetcris2 />
      <ModalInterceramic2 />

      <ModalCoprInterceramic />
      <ModalCorpAerolineas />
      <ModalCorpGaliper />

      <ModalPostReel />
      <ModalPostBetcris />
      <ModalPostCharly />
      <ModalPostImagen />
      <ModalPostTeleton />
      <ModalPostInterceramic />
      <ModalPostLg />
      <ModalPostWarner />

      <ModalVideoLila />
      <ModalVideoThalia />
      <ModalVideoAna />
      <ModalVideoAlessandra />
      <ModalVideoBeto />
      <ModalVideoCentro />

      <ModalSocialGire />
      <ModalSocialTeleton />
      <ModalSocialAntes />
      <ModalSocialImplanon />

      <ModalProductionServices />

      <ModalAiServices />
      <ModalDavidC />
      <ModalAndresB />
      <ModalALvaroC />
      <ModalRobot />
      <ModalDavidN />
      <ModalVideoDavidC1 />
      <ModalVideoDavidC2 />
      <ModalVideoDavidC3 />
      <ModalVideoAlvaro1 />
      <ModalVideoAlvaro2 />
      <ModalVideoAlvaro3 />
      <ModalVideoAndres1 />
      <ModalVideoAndres2 />
      <ModalVideoAndres3 />
      <ModalVideoDavidN1 />
      <ModalVideoDavidN2 />
      <ModalVideoDavidN3 />
      <ModalVideoRobot1 />
      <ModalVideoRobot2 />
      <ModalVideoRobot3 />

      <ModalDirectors />
      <ModalNuno />
      <ModalMaria />
      <ModalBernardo />
      <ModalCarlos />
      <ModalRodrigo />

      <ModalVideoMaria1 />
      <ModalVideoMaria2 />
      <ModalVideoMaria3 />
      <ModalVideoMaria4 />
      <ModalVideoBernardo1 />
      <ModalVideoBernardo2 />
      <ModalVideoBernardo3 />
      <ModalVideoBernardo4 />
      <ModalVideoCarlos1 />
      <ModalVideoCarlos2 />
      <ModalVideoCarlos3 />
      <ModalVideoCarlos4 />
      <ModalVideoNuno1 />
      <ModalVideoNuno2 />
      <ModalVideoNuno3 />
      <ModalVideoNuno4 />
      <ModalVideoRodrigo1 />
      <ModalVideoRodrigo2 />
      <ModalVideoRodrigo3 />
      <ModalVideoRodrigo4 />

      <ModalPhotographers />
      <ModalJose />
      <ModalYvone />
      <ModalMario />
      <ModalGregory />
      <ModalErick />
      <ModalPhotoCarlos />
      <ModalPhotoAlejandro />

      <ModalGalleryAlejandro1 />
      <ModalGalleryAlejandro2 />
      <ModalGalleryAlejandro3 />
      <ModalGalleryAlejandro4 />

      <ModalGalleryCarlos1 />
      <ModalGalleryCarlos2 />
      <ModalGalleryCarlos3 />
      <ModalGalleryCarlos4 />

      <ModalGalleryErick1 />
      <ModalGalleryErick2 />

      <ModalGalleryGregory1 />
      <ModalGalleryGregory2 />
      <ModalGalleryGregory3 />
      <ModalGalleryGregory4 />

      <ModalGalleryMario1 />
      <ModalGalleryMario2 />
      <ModalGalleryMario3 />

      <ModalGalleryYvone1 />
      <ModalGalleryYvone2 />

      <ModalGalleryJose1 />
      <ModalGalleryJose2 />
      <ModalGalleryJose3 />

      <ModalClients />

      <ModalFashionKnockout />
      <ModalFashionVassarette />
      <ModalFashionFruit1 />
      <ModalFashionFruit2 />
      <ModalFashionCurvation />
      <ModalFashionVassarette2 />
      <ModalRetratoFicj />
      <ModalRetratoGire />
      <ModalDeportesGallos />
      <ModalDeportesGatorade />
      <ModalDeportesPuma1 />
      <ModalDeportesPuma2 />
      <ModalDeportesPuma3 />
      <ModalDrinksTorres10 />
      <ModalDrinksTorres20 />
      <ModalDrinksReal />
      <ModalDrinksMagna />
      <ModalDrinksChateau />
      <ModalDrinksCodigo />
      <ModalDrinksVasija />
      <ModalDrinksVinas />
      <ModalDrinksXa />
      <ModalCultural />
      <ModalCampanasBetvip />
      <ModalCampanasBetcris />
      <ModalCampanasIdealz />

      <ModalLegal />
      <ModalPrivacy />
      <ModalPolicies />
      <ModalCookie />
    </>
  );
};

export default GlobalModals;
